import { bool } from 'prop-types';
import React, { useRef } from 'react';

import CurrencyFormat from '../../generic/CurrencyFormat';
import HoverDetails from '../../generic/HoverDetails';
import IconLink from '../../generic/IconLink';
import { invoiceShape } from '../../prop-types';
import { ABBREVIATIONS } from '../../utils/resource-abbreviations';

function InvoiceLink({ model, showIcon }) {
  const { type, status, sapStatus, billingType, amount } = model;
  const { businessModel } = model.opportunity;
  const linkRef = useRef(null);
  return (
    <>
      <span ref={linkRef}>
        <IconLink showIcon={showIcon} to={`/invoices/${model.id}/show`}>
          {ABBREVIATIONS.invoice}-{model.id}
        </IconLink>
      </span>
      <HoverDetails
        size="large"
        linkRef={linkRef}
        title={`${ABBREVIATIONS.invoice}-${model.id}`}
        fields={{
          Type: type,
          Status: status,
          'SAP Status': sapStatus,
          'Billing Type': billingType,
          Amount: <CurrencyFormat name="amount" value={amount || 0} text />,
          'Business Model': businessModel,
        }}
      />
    </>
  );
}

InvoiceLink.propTypes = {
  model: invoiceShape.isRequired,
  showIcon: bool,
};

InvoiceLink.defaultProps = {
  showIcon: false,
};

export default InvoiceLink;
